
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/core/authencation/auth.service';
import { User } from 'src/app/core/models/user.model';
import { NotificationService } from 'src/app/utils/notification-service';



@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  public readonly materialTheme$: Observable<boolean>;
  userPictureOnly: boolean = false;
  user: User;
  isVisible = false;
  // themes = [
  //   {
  //     value: 'default',
  //     name: 'Light',
  //   },
  //   {
  //     value: 'dark',
  //     name: 'Dark',
  //   },
  //   {
  //     value: 'cosmic',
  //     name: 'Cosmic',
  //   },
  //   {
  //     value: 'corporate',
  //     name: 'Corporate',
  //   },
  //   {
  //     value: 'material-light',
  //     name: 'Material Light',
  //   },
  //   {
  //     value: 'material-dark',
  //     name: 'Material Dark',
  //   },
  // ];

  // currentTheme = 'default';

  userMenu = [{ title: 'Profile' }, { title: 'Log out' }];

  public constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private breakpointService: NbMediaBreakpointsService,
    public authService: AuthService,
    public notificationService: NotificationService    
  ) {
    // this.materialTheme$ = this.themeService.onThemeChange()
    //   .pipe(map(theme => {
    //     const themeName: string = theme?.name || '';
    //     return themeName.startsWith('material');
    //   }));
  }

  ngOnInit() {
    // this.currentTheme = this.themeService.currentTheme;

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }



  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  logout() {
    this.authService.signOut();
  }
  toggle() {
    this.isVisible = !this.isVisible;
    if (this.notificationService.countUnread > 0) {
      this.notificationService.readNotification();
    }    
  }

  executeAction(data) {
    this.notificationService.doNotificationAction(data);
  }
}
